import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  FailedMessagesEndpoint,
  FailedMessageTimeFilterName,
  ShipmentEndpoint,
  ShipmentPlannerProfileEndpoint,
  ShipmentTimeFilter,
} from '../../..';
import { isPlainObject } from 'lodash';
import moment from 'moment';

@Injectable()
export class DatepickerModelRequestConverterInterceptor implements HttpInterceptor {
  private timeFilterMap: Map<string, typeof FailedMessageTimeFilterName | typeof ShipmentTimeFilter> = new Map<
    string,
    typeof FailedMessageTimeFilterName | typeof ShipmentTimeFilter
  >([
    [`${ShipmentEndpoint.Base}`, ShipmentTimeFilter],
    [`${ShipmentEndpoint.Base}${ShipmentEndpoint.Map}`, ShipmentTimeFilter],
    [`${ShipmentEndpoint.Base}${ShipmentEndpoint.Statistics}`, ShipmentTimeFilter],
    [`${ShipmentEndpoint.Base}${ShipmentEndpoint.ContainerCharges}${ShipmentEndpoint.Statistics}`, ShipmentTimeFilter],
    [`${ShipmentEndpoint.Shipment}${ShipmentEndpoint.Exports}`, ShipmentTimeFilter],
    [`${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}`, ShipmentTimeFilter],
    [`${ShipmentEndpoint.Base}${ShipmentEndpoint.ContainerCharges}`, ShipmentTimeFilter],
    [`${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Profiles}`, FailedMessageTimeFilterName],
  ]);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const endpoint = '/' + req.url.split('/').slice(3).join('/');

    if (this.timeFilterMap.has(endpoint)) {
      const dateFiltersKeys = Object.values(this.timeFilterMap.get(endpoint));
      let updatedBody = null;

      if (req.body !== null && typeof req.body === 'object' && !Array.isArray(req.body)) {
        updatedBody = this.updateRequestBody(req.body, dateFiltersKeys);
      }

      return next.handle(req.clone({ body: updatedBody }));
    }

    return next.handle(req);
  }

  private updateRequestBody(body: object, dateFiltersKeys: string[]): object {
    return Object.keys(body).reduce((acc: object, key: string) => {
      const value = body[key];

      if (value && dateFiltersKeys.includes(key)) {
        acc[key] = this.convertDatesToTimestamps(value);

        return acc;
      } else {
        if (value && isPlainObject(value)) {
          acc[key] = this.updateRequestBody(value, dateFiltersKeys);

          return acc;
        }
      }

      acc[key] = value;
      return acc;
    }, {});
  }

  private convertDatesToTimestamps(value: object): object {
    return Object.keys(value).reduce((dateAcc: object, dateKey: string) => {
      const date = value[dateKey];
      if (moment.isMoment(date) || date instanceof Date) {
        dateAcc[dateKey] = +date;
        return dateAcc;
      }

      dateAcc[dateKey] = date;

      return dateAcc;
    }, {});
  }
}
